import React from 'react';
import { FormattedMessage } from 'react-intl';

import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service';
import type {
  CriteriaInformations,
  ExistingFiltersHelpers,
} from '../../../../../../pages/products-page/purchase-orders/filter-options/types';
import type { AppliedFilter } from '../../map-freight-filters-to-api-params';
import { statusMessages } from './messages';

export const STATUS = 'status';

const StatusValueMessages: Record<string, typeof statusMessages.quoted> = {
  Quoted: statusMessages.quoted,
  Booked: statusMessages.booked,
  Cancelled: statusMessages.cancelled,
};

export default {
  id: STATUS,
  type: OptionFormTypes.TYPE_IS_RADIO_OPTIONS,
  filterValue: STATUS,
  displayName: (appliedFilters: AppliedFilter[]) => {
    const statusFilters = appliedFilters.filter((filter) => filter.filterById === STATUS);
    if (statusFilters.length === 0) {
      return <FormattedMessage {...statusMessages.status} />;
    }
    if (statusFilters.length === 1) {
      const statusKey = statusFilters[0].criterionArgumentValue as string;
      const msg = StatusValueMessages[statusKey];
      return msg ? <FormattedMessage {...msg} /> : statusKey;
    }
    return <FormattedMessage {...statusMessages.multipleStatuses} />;
  },
  render: (criteriaInformations: CriteriaInformations, existingFiltersHelpers: ExistingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_RADIO_OPTIONS, criteriaInformations, existingFiltersHelpers);
  },
};
